module.exports = __webpack_public_path__ + "static/media/saveIcon.a4a54638.svg";